import { api } from '../../utils/api'
import type { CrewModeStreamId } from '../../utils/api'
import { getActiveTenantKey } from '../../offline/tenant'
import { setWaterLogCrewModeEnabled } from './waterLogFeatureFlag'
import { setFeedCrewModeEnabled } from './feedLogFeatureFlag'
import { setMortalityCrewModeEnabled } from './mortalityLogFeatureFlag'
import { setWeightSampleCrewModeEnabled } from './weightSampleLogFeatureFlag'

// Server-Side Flag Enforcement v0 follow-up: replaces the devtools-console
// workflow (docs/crew-mode/dev-verification-runbook.md §2) with an automatic
// sync from the real FarmFeatureFlag table into the existing per-farm
// localStorage cache that Sidebar.tsx and CrewModeHome already read. No
// caller needs to change how it reads "is this stream enabled" — this only
// changes who writes the cache.

const setters: Record<CrewModeStreamId, (farmId: string, enabled: boolean, tenantKey?: string) => void> = {
  water: setWaterLogCrewModeEnabled,
  feed: setFeedCrewModeEnabled,
  mortality: setMortalityCrewModeEnabled,
  weightSample: setWeightSampleCrewModeEnabled
}

/**
 * Best-effort, never throws: Charter O-5 — nothing here may block on a
 * network round-trip. A failed or offline sync just leaves the previous
 * cached values in place until the next opportunistic trigger.
 */
export const syncCrewModeFlagsForFarm = async (
  farmId: string,
  tenantKey: string = getActiveTenantKey()
): Promise<void> => {
  if (!farmId) return
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return

  try {
    const flags = await api.crewModeFlags.list(farmId)
    for (const stream of Object.keys(setters) as CrewModeStreamId[]) {
      setters[stream](farmId, Boolean(flags[stream]), tenantKey)
    }
  } catch {
    // best-effort; keep whatever was cached locally
  }
}
